
import useOneTrust from '../../hooks/useOneTrust';

const WHITE = '#ffffff';

export default function OneTrustLink({ color = WHITE }) {
    const isEnabled = useOneTrust();

    // OneTrust only binds `.ot-sdk-show-settings` elements present when the SDK loads,
    // so links rendered after client-side navigation must open the preference center directly.
    const handleClick = (e) => {
        e.preventDefault();
        window.OneTrust?.ToggleInfoDisplay();
    };

    return (
        <>
            {isEnabled && (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <a
                    // eslint-disable-next-line no-script-url
                    href="javascript:void(0)"
                    id="newsmax-cookie-preferences"
                    onClick={handleClick}
                    style={{ color: color, background: 'none', border: 'none', padding: 0, cursor: 'pointer', textDecoration: 'underline' }}
                >
                    Manage Cookies
                </a>
            )}
        </>
    );
}
